import React, { useEffect } from "react";
import Title from "../../new-components/title/Title";
import { Link, useLocation, useParams } from "react-router-dom";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";
import NewFooter from "../../NewFooter";
import "../food-and-beverages/FoodAndBeverages.scss";
import ServiceImage from "../../assets/new_imgs/ServiceImage.jpg";
import News from "../../assets/new_imgs/News1.jpg";
import AlcoholImage from "../../assets/new_imgs/Alcohol.jpg";
import { trackCategoryViewed } from "../../utils/mixpanel";

const ExternalServices = () => {
  const params = useParams();
  const lang = localStorage.getItem("lang");
  const location = useLocation();
  const metadata = location.state?.metadata;
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  // useEffect(() => {
  //   if (metadata) {
  //     trackCategoryViewed({
  //       category_id: "",
  //       category_name: "External Services",
  //       category_type: "external_services",
  //     });
  //   }
  // }, []);

  console.log("metadata", metadata);
  return (
    <div className={`food  ${lang === "AR" && "arabic"}`}>
      <Title title={"External Services"} />

      <div className="box_food image_services">
        {metadata?.map((service) => {
          // if (service.id === 25) {
          //   return (
          //     <Link to={`/${params.room_uuid}/external-services/things-to-do`}>
          //       <img src={News} alt="" className="service_img" />
          //       <img src={Overllay} alt="" className="overlay" />
          //       <h6 className="sub_title">{service?.display_name}</h6>
          //     </Link>
          //   );
          // }
          if (service.id === 10) {
            return (
              <Link
                to={`/${params.room_uuid}/external-services/pharmacy`}
                onClick={() => {
                  trackCategoryViewed({
                    category_id: service.id,
                    category_name: service?.display_name || "",
                    category_type: "Pharmacy",
                  });
                }}
              >
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/pharmacy.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
          if (service.id === 11) {
            return (
              <Link
                to={`/${params.room_uuid}/external-services/flowers`}
                onClick={() => {
                  trackCategoryViewed({
                    category_id: service.id,
                    category_name: service?.display_name || "",
                    category_type: "Flowers",
                  });
                }}
              >
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/flowers.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
          if (service.id === 9) {
            return (
              <Link
                to={`/${params.room_uuid}/external-services/supermarket`}
                onClick={() => {
                  trackCategoryViewed({
                    category_id: service.id,
                    category_name: service?.display_name || "",
                    category_type: "Supermarket",
                  });
                }}
              >
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/supermarket.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
          if (service.id === 16) {
            return (
              // <Link to={`/${params.room_uuid}/external-services/entertainment`}>
              <Link
                to={`/${params.room_uuid}/entertainment/categories/`}
                onClick={() => {
                  trackCategoryViewed({
                    category_id: service.id,
                    category_name: service?.display_name || "",
                    category_type: "Entertainment",
                  });
                }}
              >
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/entertainment.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
          if (service.id === 13) {
            return (
              <Link
                to={`/${params.room_uuid}/external-services/cars`}
                onClick={() => {
                  trackCategoryViewed({
                    category_id: service.id,
                    category_name: service?.display_name || "",
                    category_type: "Cars",
                  });
                }}
              >
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/rental.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />{" "}
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
          if (service.id === 24) {
            return (
              <Link
                // to={`/${params.room_uuid}/luxurios/companies`}
                to={`/${params.room_uuid}/luxurios/categories`}
                onClick={() => {
                  trackCategoryViewed({
                    category_id: service.id,
                    category_name: service?.display_name || "",
                    category_type: "Luxurious",
                  });
                }}
              >
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/Luxurious.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />{" "}
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
          if (service.id === 6) {
            return (
              <Link
                to={`/${params.room_uuid}/external-services/taxi`}
                onClick={() => {
                  trackCategoryViewed({
                    category_id: service.id,
                    category_name: service?.display_name || "",
                    category_type: "Taxi",
                  });
                }}
              >
                <img
                  src={"https://d3l5wxnahfuscp.cloudfront.net/static/taxi.png"}
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
          if (service.id === 21) {
            return (
              <Link
                to={`/${params.room_uuid}/external-services/hh-taxi`}
                onClick={() => {
                  trackCategoryViewed({
                    category_id: service.id,
                    category_name: service?.display_name || "",
                    category_type: "HH Taxi",
                  });
                }}
              >
                <img
                  src={"https://d3l5wxnahfuscp.cloudfront.net/static/taxi.png"}
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />

                <h6 className="sub_title">
                  {lang === "AR" ? service.service_name : service.display_name}
                </h6>
              </Link>
            );
          }
          if (service.id === 14) {
            return (
              <Link
                to={`/${params.room_uuid}/external-services/hh-housekeeping`}
                onClick={() => {
                  trackCategoryViewed({
                    category_id: service.id,
                    category_name: service?.display_name || "",
                    category_type: "HH Housekeeping",
                  });
                }}
              >
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/Housekeeping.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }

          if (service.id === 32) {
            return (
              <Link
                to={`/${params.room_uuid}/sims`}
                onClick={() => {
                  trackCategoryViewed({
                    category_id: service.id,
                    category_name: service?.display_name || "",
                    category_type: "SIMs",
                  });
                }}
              >
                <img
                  src={"https://d3l5wxnahfuscp.cloudfront.net/static/esim.png"}
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
          if (service.id === 34) {
            return (
              <Link
                to={`/${params.room_uuid}/mmi`}
                onClick={() => {
                  trackCategoryViewed({
                    category_id: service.id,
                    category_name: service?.display_name || "",
                    category_type: "MMI",
                  });
                }}
              >
                <img src={AlcoholImage} alt="" className="service_img" />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
        })}
      </div>
      <NewFooter />
    </div>
  );
};

export default ExternalServices;
